export default "__VITE_ASSET__CyzXtqZC__"